<template>
  <div class="ion-padding">
    <ion-text color="primary">
      Optimize for the {{currency}} amount you'd like to receive monthly
    </ion-text>

    <ion-item lines="full">
      <ion-label position="floating">Value</ion-label>
      <ion-input type="number" v-model="dataValue" min="1" required></ion-input>
      <ion-icon :icon="iconInfo" slot="end" @click.stop="valueInfo"></ion-icon>
    </ion-item>

    <ion-item-divider>
      <ion-label>Advanced settings</ion-label>
    </ion-item-divider>

    <ion-item lines="full">
      <ion-label position="floating">Max iterations</ion-label>
      <ion-input type="number" v-model="dataIterations" min="1"
                 required></ion-input>
      <ion-icon :icon="iconInfo" slot="end" @click.stop="maxIterInfo"></ion-icon>
    </ion-item>

    <ion-item lines="full">
      <ion-label position="floating">Toleration</ion-label>
      <ion-input type="number" v-model="dataToleration" min="0"
                 required></ion-input>
      <ion-icon :icon="iconInfo" slot="end" @click.stop="tolerationInfo"></ion-icon>
    </ion-item>

    <div class="ion-margin">
      <ion-button color="success" @click="save()">Save</ion-button>
      <ion-button color="danger" @click="cancel()">Cancel</ion-button>
    </div>

  </div>
</template>

<script>
import {
  informationCircle as iconInfo,
} from 'ionicons/icons';

import {
  IonItem,
  IonItemDivider,
  IonLabel,
  IonText,
  IonNote,
  IonInput,
  IonButton,
  IonIcon,

  modalController,
} from '@ionic/vue';

import {info} from "@/lib";

export default {
  name: "ObjDpm",
  components: {
    IonItem,
    IonItemDivider,
    IonLabel,
    IonText,
    IonNote,
    IonInput,
    IonButton,
    IonIcon,
  },

  props: {
    value: {
      type: Number,
      default: 100,
    },

    iterations: {
      type: Number,
      default: 1000,
    },

    toleration: {
      type: Number,
      default: 1,
    },

    currency: {
      type: String,
      default: "USD",
    },
  },

  data() {
    return {
      dataValue: this.value,
      dataIterations: this.iterations,
      dataToleration: this.toleration,
      iconInfo,
    }
  },

  methods: {
    save() {
      modalController.dismiss({
        value: this.dataValue,
        iterations: parseInt(this.dataIterations, 10),
        toleration: parseInt(this.dataToleration, 10),
      });
    },

    cancel() {
      modalController.dismiss();
    },

    async valueInfo() {
      await info('Value',
          "The value specifies the amount in selected currency you'd like to receive monthly as dividends. Since dividends payouts often occur on a quarterly or even semi-annual basis, the value is divided accordingly to indicate the average monthly amount.");
    },

    async maxIterInfo() {
      await info('Maximum number of iterations',
          "The generation process is done in many steps (iterations). This knob allows you to change the maximum amount of iterations you'd want to wait for the solution. Higher number can yield portfolios with a better precision but it can take longer time and consume more CPU.");
    },

    async tolerationInfo() {
      await info('Toleration',
          "This value specifies the acceptable toleration level for the portfolio solution. For example, if you selected '$100' as a value above, and toleration is '1', the optimization will terminate successfully for 100+-1 -- 99 to 101 range.");
    },
  }
}
</script>